/**
 * AccountsAPI
 *
 * Contact: support-ucc@cardcenter.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AccountDetails } from '../model/accountDetails';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class AccountDetailsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Returns the details of the specified account.
     * Returns the details of the specified account. Only accounts are returned where the user does have access to. Only works for liable accounts.
     * @param accountId The ID of the account to get details from.
     * @param uCCCorrelationId identifier used for correlating requests
     * @param include Comma separated list of included content. Options are - \&#39;cards\&#39;, card information otherwise available in cards API links is included as _embedded content. Performance of call is better if card information is not included. - \&#39;invoice-delivery-method\&#39;, invoice delivery method is included in attribute invoice-delivery-method, otherwise will be null.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAccountDetails(accountId: string, uCCCorrelationId?: string, include?: Array<string>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<AccountDetails>;
    public getAccountDetails(accountId: string, uCCCorrelationId?: string, include?: Array<string>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<AccountDetails>>;
    public getAccountDetails(accountId: string, uCCCorrelationId?: string, include?: Array<string>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<AccountDetails>>;
    public getAccountDetails(accountId: string, uCCCorrelationId?: string, include?: Array<string>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling getAccountDetails.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (include) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...include].join(COLLECTION_FORMATS['csv']), 'include');
        }

        let localVarHeaders = this.defaultHeaders;
        if (uCCCorrelationId !== undefined && uCCCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('UCC-Correlation-Id', String(uCCCorrelationId));
        }

        // authentication (BasicRead) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BasicRead', 'Authorization', localVarHeaders);

        // authentication (UserRead) required
        localVarHeaders = this.configuration.addCredentialToHeaders('UserRead', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/accounts/${this.configuration.encodeParam({name: "accountId", value: accountId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AccountDetails>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
